import { defineMessages } from 'react-intl'

export default defineMessages({
  required: {
    id: 'AudienceTargeting.Required',
    defaultMessage: '*'
  },
  and: {
    id: 'AudienceTargeting.And',
    defaultMessage: 'And'
  },
  or: {
    id: 'AudienceTargeting.Or',
    defaultMessage: 'Or'
  },
  includes: {
    id: 'AudienceTargeting.Includes',
    defaultMessage: 'Includes'
  },
  excludes: {
    id: 'AudienceTargeting.Excludes',
    defaultMessage: 'Excludes'
  },
  audienceRule: {
    id: 'AudienceTargeting.RuleName',
    defaultMessage: 'Rule {index}'
  },
  filterDelete: {
    id: 'AudienceTargeting.FilterDelete',
    defaultMessage: 'Delete Filter'
  },
  ruleDefinition: {
    id: 'AudienceTargeting.ruleDefinition',
    defaultMessage: 'Rule Definition:'
  },
  defaultAttribute: {
    id: 'AudienceTargeting.defaultAttribute',
    defaultMessage: 'Select an attribute'
  },
  addAudience: {
    id: 'AudienceTargeting.AddAudience',
    defaultMessage: 'Add Audience'
  },
  confirmDeleteAudience: {
    id: 'AudienceTargeting.ConfirmDeleteAudience',
    defaultMessage: 'Are you sure you want to delete this audience targeting rule?'
  },
  individualPlaceholder: {
    id: 'AudienceTargeting.Attribute.Individual.Placeholder',
    defaultMessage: 'Email, Name or Number'
  },
  individual: {
    id: 'AudienceTargeting.Attribute.Individual',
    defaultMessage: 'Individual'
  }
})
